/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankIdCreditCards200,
  GetApiV1BankIdCreditCards401,
  GetApiV1BankIdCreditCards500,
  GetApiV1BankIdCreditCardsPathParams,
  GetApiV1BankIdCreditCardsQueryResponse,
} from "../../types/bankAuxiliaresController/GetApiV1BankIdCreditCards.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1BankIdCreditCardsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BankIdCreditCardsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankIdCreditCards200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1BankIdCreditCards200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankIdCreditCards401Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdCreditCards401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankIdCreditCards500Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdCreditCards500>;

export const getApiV1BankIdCreditCardsQueryResponseSchema = z.lazy(
  () => getApiV1BankIdCreditCards200Schema,
) as unknown as ToZod<GetApiV1BankIdCreditCardsQueryResponse>;
